import i18n from 'i18n';
import { $Dictionary } from 'i18next/typescript/helpers';
import { useCallback } from 'react';
import { useTranslation as useOrignialNextTranslation } from 'react-i18next';

import { Paths } from 'utils/types';

import en from '../../public/locales/en/common.json';

export type TranslationKeys = {
  common: Paths<typeof en>; //gets the keys from the json file and creates a type for them
};

export type TranslationFunction = (key: TranslationKeys['common'], options?: $Dictionary | undefined) => string;

export const useTranslation = <T extends keyof TranslationKeys>(ns: T) => {
  const { language } = i18n;
  const { t } = useOrignialNextTranslation(ns);

  const translate = useCallback<TranslationFunction>((key, options) => t(key, options), [t]);

  return { t: translate, lang: language };
};

export const getTypedTranslate =
  <T extends keyof TranslationKeys>(ns: T): TranslationFunction =>
  (key, options) =>
    i18n.t(key, { ns, ...options });
